function ToPersianNumber(num) {
  if (num) {
    const farsiDigits = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
    if (num.toString().includes(",")) {
      let commaContained = num.toString().split(",");
      let persianCommaContained = [];
      commaContained.forEach((element) => {
        persianCommaContained.push(
          element
            .toString()
            .split("")
            .map((x) => farsiDigits[x])
            .join("")
        );
      });
      return persianCommaContained.join(",");
    } else if (num.toString().includes(".")) {
      let dotContained = num.toString().split(".");
      let persianDotContained = [];
      dotContained.forEach((element) => {
        persianDotContained.push(
          element
            .toString()
            .split("")
            .map((x) => farsiDigits[x])
            .join("")
        );
      });
      return persianDotContained.join(".");
    } else {
      if (num.toString().startsWith("+98")) {
        return num
          .toString()
          .replace("+98", "0")
          .split("")
          .map((x) => farsiDigits[x])
          .join("");
      } else {
        return num
          .toString()
          .split("")
          .map((x) => farsiDigits[x])
          .join("");
      }
    }
  } else {
    return num;
  }
}
export default ToPersianNumber;
